module.exports = __webpack_public_path__ + "static/mai-logo-2-f725c40f08c6da1e75e8574c30a39638.svg";